import React from 'react'
import { Link } from 'react-router-dom';
import Chart from "react-apexcharts";

import { InvestmentData } from './Components/InvestmentData'
import { TotalInvestmentChart } from './Components/TotalInvestmentChart';
import { MonthlyRevenueChart } from './Components/MonthlyRevenueChart';
import { MyInvestmentData } from './Components/MyInvestmentData'
import { TrendingStockColumns, TrendingStockTableData } from './Components/TrendingStockData';

import DataTableHeader from '../../../Common/DataTableHeader/DataTableHeader';
import DataTable from '../../../Common/DataTable/DataTable';
import DataTableFooter from '../../../Common/DataTableFooter/DataTableFooter';

const Investment = () => {

    // x---------------------------------x  Trending Stock Table Data // x---------------------------------x  */ }
    const dataT = TrendingStockTableData.map((data, index) => {
        return {
            slNo: data.slNo,
            name: data.name,
            price: data.price,
            return: (
                <>
                    <span className={data.text_color}>{data.return}</span>
                </>
            )
        };
    });


    // x---------------------------------x All Chart Data x---------------------------------x  */ }
    const chartData = [
        {
            id: "chart-one",
            title: "Yearly Total Investment",
            link: "/Investments",
            // x---------------------------------x TotalInvestment Chart // x---------------------------------x 
            chartOptions: TotalInvestmentChart,
        },
        {
            id: "chart-two",
            title: "Monthly Revenue",
            link: "/Investments",
            // x---------------------------------x MonthlyRevenue Chart // x---------------------------------x 
            chartOptions: MonthlyRevenueChart,
        },
    ];

    return (
        <div>
            {/* // x---------------------------------x Division // x---------------------------------x  */}
            <div className="grid xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 justify-center gap-4">
                {InvestmentData.map((data, index) => {
                    return (
                        <div className="col-lg-4 col-md-6" key={index}>
                            <div className="card border-none bg-transparent h-100">
                                <div className="card-body rounded-2xl p-4">
                                    <div className="flex items-center">
                                        <div className={`card-img w-16 h-16 rounded-full mr-4 flex items-center justify-center ${data.icon_bg}`}>
                                            {data.icon}
                                        </div>
                                        <div className="card-text">
                                            <p className="text-dark opacity-50 text-base m-0">{data.title}
                                            </p>
                                            <p className="text-dark font-bold text-lg m-0">{data.amount}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

            {/* // x---------------------------------x Yearly Total Investment / Monthly Revenue // x---------------------------------x  */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-3">
                {chartData.map((data) => (
                    <div key={data.id} className="h-full">
                        <div className="bg-transparent h-full">
                            <div className="flex justify-between p-4">
                                <h3 className="text-dark sm:text-2xl text-base font-semibold">{data.title}</h3>
                                <Link
                                    to={data.link}
                                    className="text-dark sm:text-2xl text-base font-semibold block lg:hidden"
                                >
                                    See all
                                </Link>
                            </div>
                            <div className="card-body rounded-2xl bg-white p-3">
                                <div style={{ width: "100%", height: "300px" }} id={data.id}>
                                    <Chart
                                        options={data.chartOptions}
                                        series={data.chartOptions.series}
                                        type={data.chartOptions.chart.type}
                                        height={data.chartOptions.chart.height}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* // x---------------------------------x My Investment / Trending Stock // x---------------------------------x  */}
            <div className="grid grid-cols-1 xl:grid-cols-7 gap-3 mt-3">
                {/* // x---------------------------------x My Investment // x---------------------------------x  */}
                <div className="xl:col-span-4">
                    <div className="bg-transparent h-full">
                        <div className="flex justify-between items-center">
                            <h3 className="text-dark sm:text-2xl p-4 font-semibold">My Investment</h3>
                        </div>
                        <ul className="grid grid-cols-1 card-body p-2 rounded-2xl" id="MyClients">
                            {MyInvestmentData.map((data, index) => (
                                <li className="col-span-1" key={index}>
                                    <div className="bg-card p-3 rounded-lg text-dark">
                                        <div className="flex flex-col md:flex-row md:items-center bg-body p-5 rounded-lg space-y-4 md:space-y-0">
                                            <div className="w-full md:w-6/12 lg:w-5/12">
                                                <div className="flex gap-4 items-center">
                                                    <div className="avatar lg no-thumbnail rounded-full">
                                                        {data.icon}
                                                    </div>
                                                    <div>
                                                        <h6 className="text-base lg:text-lg mb-1">{data.investmentHeading}</h6>
                                                        <span className="text-sm text-muted">{data.headingText}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-6/12 lg:w-7/12">
                                                <ul className="list-none flex flex-col sm:flex-row justify-between space-y-3 md:space-y-0 md:space-x-5">
                                                    <li>
                                                        <div className="text-left md:text-right">
                                                            <h6 className="text-base lg:text-lg mb-1">{data.amount}</h6>
                                                            <span className="text-sm text-muted">{data.amountText}</span>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="text-left md:text-center">
                                                            <h6 className={`text-base lg:text-lg mb-1 ${data.textColor}`}>{data.numberOfCount}</h6>
                                                            <span className="text-sm text-muted">{data.countText}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* // x---------------------------------x  Trending Stock // x---------------------------------x  */}
                <div className="xl:col-span-3">
                    <div className="bg-transparent">
                        <div className="flex justify-between items-center">
                            <h3 className="text-dark p-4 sm:text-2xl font-semibold">Trending Stock</h3>
                            <Link to="/Investments" className="text-dark text-end text-base font-semibold block sm:hidden">see all</Link>
                        </div>
                        <div className="rounded-2xl mb-3 sm:mb-0 card-body p-5">
                            {/* // x---------------------------------x  Trending Stock Table x---------------------------------x  */}
                            <DataTableHeader />
                            <DataTable columns={TrendingStockColumns} data={dataT} />
                            <DataTableFooter dataT={"dataT"} />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Investment